function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 6 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { CardBuilder } from "./Helpers/CardBuilder";
import { SubscriptionsApiService } from "./Services/SubscriptionsApiService";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
export var MppSubscriptions = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppSubscriptions, _ComponentBase);

  var _super = _createSuper(MppSubscriptions);

  function MppSubscriptions() {
    _classCallCheck(this, MppSubscriptions);

    return _super.call(this);
  }

  _createClass(MppSubscriptions, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback() {
      this.loadAttributes();

      if (!!this._$subscriptionsForm) {
        this._$congregationIdContainer.style.display = "block";

        if (this.hasCongregation()) {
          this._$congregationIdContainer.style.display = "none";
        }

        this.runSearchAndFilter();
      }
    }
  }, {
    key: "hasCongregation",
    value: function hasCongregation() {
      return this.congregationIdAttribute && Number(this.congregationIdAttribute) > 0;
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.congregationIdAttribute = this.getAttribute("congregationid") || "0";
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppSubscriptions.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this._i18n = i18n; //Load initial values of tag attributes:

                this.loadAttributes(); // HTML Template:

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="mySubscriptionsNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="mySubscriptionsWrapper" style="display: none;"><div class="mppw-component-container mpp-subscriptions"><div id="testContainer"></div><div class="mpp-subscriptions--header" id="searchContainer"><h1>${this._i18n.pageTitle}</h1><input type="hidden" id="event" name="eventId" class="search-option"/> <input type="hidden" id="program" name="programId" class="search-option"/><div class="mppw-form-field mppw-form-field__static-container" id="congregationIdContainer"><select name="congregationId" class="mppw-form-field__control search-option" id="congregationId" value=""></select> <label class="mppw-form-field__label" for="congregationId">${ this._i18n.congregationLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="keyword" class="mppw-form-field__control search-option mpp-subscriptions--search-option" type="text" id="searchText"/> <label class="mppw-form-field__label" for="searchText">${this._i18n.searchText}</label></div></div><form class="mppw-form mppw-form-validate" id="subscriptionsForm"><div id="subscriptionsBody" class="mpp-subscriptions--body"></div><div id="subscriptionsResponded" class="mppw-alert mppw-alert__success" style="display: none"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.thankYouMessage}</span></div><div id="subscriptionsEmpty" class="mppw-alert mppw-alert__warning" style="display: none"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.emptySubscriptionsMessage}</span></div><div class="mppw-row"><div class="mppw-col"><div class="mppw-left">${CardBuilder.BuildSubscriptionCheckbox('BulkEmailOptOut', false)} <span class="mpp-subscriptions--checkboxlabel">${this._i18n.bulkEmailOptOutLabel}</span></div></div><div class="mppw-col"><div class="mppw-right"><input type="submit" class="mppw-btn primary" id="updateButton" value="${this._i18n.updateButtonText}"/></div></div></div></form></div></div>` ; // Select items from template.  Use $ as convention indicating a DOM element:

                this._$subscriptionsForm = this._root.querySelector("#subscriptionsForm");
                this._$searchText = this._root.querySelector("#searchText");
                this._$updateButton = this._root.querySelector("#updateButton");
                this._$subscriptionsBody = this._root.querySelector("#subscriptionsBody");
                this._$subscriptionsResponded = this._root.querySelector("#subscriptionsResponded");
                this._$subscriptionsEmpty = this._root.querySelector("#subscriptionsEmpty");
                this._$testContainer = this._root.querySelector('#testContainer');
                this._$bulkEmailOptOutCheck = this._root.querySelector('#BulkEmailOptOut');
                this._$mySubscriptionsWrapper = this._root.querySelector("#mySubscriptionsWrapper");
                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loginButton = this._root.querySelector("#loginButton");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$searchContainer = this._root.querySelector("#searchContainer");
                this._$congregationIdContainer = this._root.querySelector("#congregationIdContainer");
                this._$congregationId = this._root.querySelector("#congregationId"); // Services

                this._subscriptionsService = new SubscriptionsApiService();
                this.ShowLoadingIndicator();
                this.TryLoginUser();

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "LoadPage",
    value: function LoadPage() {
      this.GetMySubscriptions();
      this.GetContactBulkEmailOptOut();
      this.BindEventListeners();
      this.HideLoadingIndicator();
    }
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this2 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        _this2._$loginButtonContainer.style.display = "none";
        _this2._$mySubscriptionsWrapper.style.display = ""; // Load page

        _this2.LoadPage();
      }, function () {
        _this2._$mySubscriptionsWrapper.style.display = "none";
        _this2._$loginButtonContainer.style.display = "";

        _this2.HideLoadingIndicator();

        _this2.BindEventListeners();
      });
    }
  }, {
    key: "GetCongregations",
    value: function GetCongregations(inputArray) {
      var outputArray = [];
      var needAddUnassigned = false;

      for (var i = 0; i < inputArray.length; i++) {
        if (!outputArray.find(function (c) {
          return c.id === inputArray[i].congregation_ID;
        })) {
          if (inputArray[i].congregation_Name == undefined) {
            needAddUnassigned = true;
          } else {
            var congregation = {
              id: inputArray[i].congregation_ID,
              name: inputArray[i].congregation_Name,
              disabled: false
            };
            outputArray.push(congregation);
          }
        }
      }

      if (needAddUnassigned) {
        var _congregation = {
          id: null,
          name: "- Not Assigned -",
          disabled: false
        };
        outputArray.push(_congregation);
      }

      return outputArray;
    }
  }, {
    key: "GetMySubscriptions",
    value: function GetMySubscriptions() {
      var _this3 = this;

      this._subscriptionsService.GetSubscriptions().then(function (data) {
        _this3.BuildSubscriptionsCards(_this3._$subscriptionsBody, data, _this3._i18n.noDescriptionText, _this3._i18n.showDescriptionText, _this3._i18n.hideSubscriptionText);

        DropdownBuilder.LoadDropdown(_this3._$congregationId, _this3.GetCongregations(data), _this3._i18n.congregationPlaceholderText);
        _this3._$congregationIdContainer.style.display = "block";

        if (_this3.hasCongregation()) {
          _this3._$congregationId.value = _this3.congregationIdAttribute;
          _this3._$congregationIdContainer.style.display = "none";

          _this3.runSearchAndFilter();
        }
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners() {
      var _this4 = this;

      this._$subscriptionsForm.addEventListener('submit', function (event) {
        event.preventDefault();
        var formData = new FormData(_this4._$subscriptionsForm);

        _this4._subscriptionsService.UpdateSubscriptions(formData).then(function () {
          _this4._$subscriptionsEmpty.style.display = "none";
          _this4._$subscriptionsResponded.style.display = "block";
        })["catch"](function (error) {
          _this4._$subscriptionsEmpty.style.display = "none";
          _this4._$subscriptionsResponded.style.display = "block";
          console.error(error);
        });
      });

      this._$bulkEmailOptOutCheck.addEventListener('change', function (event) {
        _this4.SetContactBulkEmailOptOut(event.target.checked);
      });

      this.searchTimeout = null;

      this._$searchText.addEventListener("keyup", function () {
        clearTimeout(_this4.searchTimeout);
        _this4.searchTimeout = setTimeout(function () {
          _this4.runSearchAndFilter();
        }, 200);
      });

      this._$loginButton.addEventListener("click", function () {
        OAuthService.SignIn();
      });

      this._$congregationId.addEventListener('change', this.handleCongregationChange.bind(this));
    }
  }, {
    key: "runSearchAndFilter",
    value: function runSearchAndFilter() {
      var _this5 = this;

      var searchText = this._$searchText.value;
      var congregationId;

      if (this.hasCongregation()) {
        congregationId = Number(this.congregationIdAttribute);
        this._$congregationId.value = "";
        this._$searchText.value = "";
        searchText = "";
      } else if (this._$congregationId.value !== "") {
        congregationId = this._$congregationId.value;
      }

      this._subscriptionsService.GetSubscriptions(searchText, congregationId).then(function (data) {
        _this5.BuildSubscriptionsCards(_this5._$subscriptionsBody, data, _this5._i18n.noDescriptionText, _this5._i18n.showDescriptionText, _this5._i18n.hideSubscriptionText);
      });
    }
  }, {
    key: "handleCongregationChange",
    value: function handleCongregationChange() {
      this.runSearchAndFilter();
    }
  }, {
    key: "GetContactBulkEmailOptOut",
    value: function GetContactBulkEmailOptOut() {
      var _this6 = this;

      this._subscriptionsService.GetBulkEmailOptOut().then(function (data) {
        _this6._$bulkEmailOptOutCheck.checked = data;
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }, {
    key: "SetContactBulkEmailOptOut",
    value: function SetContactBulkEmailOptOut(optOut) {
      var _this7 = this;

      this._$subscriptionsEmpty.style.display = "none";
      this._$subscriptionsResponded.style.display = "none";

      this._subscriptionsService.BulkEmailOptOut(optOut).then(function (data) {
        _this7._$subscriptionsEmpty.style.display = "none";
        _this7._$subscriptionsResponded.style.display = "block";
      })["catch"](function (error) {
        console.error(error);
      });
    }
  }, {
    key: "BuildSubscriptionsCards",
    value: function BuildSubscriptionsCards(container, data, noDescriptionText, showDescriptionText, hideDescriptionText) {
      // Remove existing html from container:
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }

      if (data.length) {
        this._$subscriptionsEmpty.style.display = "none";
        this._$updateButton.disabled = false;

        for (var i = 0; i < data.length; i++) {
          var _data$i = data[i],
              title = _data$i.title,
              publicationId = _data$i.publicationId,
              description = _data$i.description,
              imageUrl = _data$i.imageUrl,
              subscribed = _data$i.subscribed;
          container.innerHTML += CardBuilder.BuildMultiSelectCard(i, imageUrl, title, publicationId, description, subscribed, noDescriptionText, showDescriptionText, hideDescriptionText);
        }
      } else {
        this._$subscriptionsEmpty.style.display = "block";
        this._$updateButton.disabled = true;
      }
    }
  }, {
    key: "ShowLoadingIndicator",
    value: function ShowLoadingIndicator() {
      this._$loadingContainer.style.display = "";
    }
  }, {
    key: "HideLoadingIndicator",
    value: function HideLoadingIndicator() {
      this._$loadingContainer.style.display = "none";
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Subscriptions",
        tag: "mpp-subscriptions",
        configurationItems: [{
          name: "Congregation",
          attribute: "congregationid",
          description: "Filters the results by a single Congregation ID.",
          required: false,
          type: "foreignkey",
          fkTable: "Congregations",
          fkFilter: "",
          fkSingleName: "Congregation"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["congregationid"];
    }
  }]);

  return MppSubscriptions;
}(ComponentBase);
MppSubscriptions.registerComponent(MppSubscriptions.WidgetDetails.tag, MppSubscriptions);